import { post,put,del,get } from './axios'


export const selectSurveyList = async (params) => {
  const { status, data } = await get("/survey/selectSurveyListAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const updateSurvey = async (params) => {
  const { status, data } = await post("/survey/updateSurveyAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const selectFreeSurveyList = async (params) => {
  const { status, data } = await get("/survey/selectFreeSurveyListAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const updateFreeSurvey = async (params) => {
  const { status, data } = await post("/survey/updateFreeSurveyAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}